import { Injectable } from '@angular/core';
import { CustomOccProduct, CustomProduct } from '@product/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductUnitsNormalizer implements Converter<
  Partial<Omit<CustomOccProduct, 'units'>>,
  Partial<CustomProduct>
> {
  convert(source: Partial<Omit<CustomOccProduct, 'units'>>, target?: CustomProduct): Partial<CustomProduct> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (source.unitPrices) {
      target.units = source.unitPrices.map(({ unit, marketingUnit, saleUnit }) => ({
        baseUnit: unit,
        marketingUnit,
        saleUnit,
      }));
    }

    return target;
  }
}
